import {
  Component,
  ComponentRef,
  ElementRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from "@angular/core";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW7000Model } from "./kymw7000.model";
import { FlexGrid } from '@grapecity/wijmo.grid';
import { CheckFeatureSelectionService } from "./api-services/check-feature-selection.service";
import { GetSelectionRequestListResponse, GetSelectionRequestListService } from "./api-services/get-selection-request-list.service";
import { SaveFeatureInfoByPlannerService } from "./api-services/save-feature-info-by-planner.service";
import { GetTargetListByFeatureGoodsSelectionResponse, GetTargetListByFeatureGoodsSelectionService } from "./api-services/get-target-list-by-feature-goods-selection.service";
import { GetSelectionGoodsListResponse, GetSelectionGoodsListService } from "./api-services/get-selection-goods-list.service";
import { GetMediumListByOrderService } from "./api-services/get-medium-list-by-order.service";
import { GetGoodsCoopService } from "./api-services/get-goods-coop.service";
import { GetGoodsBaseService } from "./api-services/get-goods-base.service";
import { GetFeatureThemaService } from "./api-services/get-feature-thema.service";
import { GetFeatureListService } from "./api-services/get-feature-list.service";
import { DownloadFeatureGoodsService } from "./api-services/download-feature-goods.service";
import { ConfirmFeatureInfoByPlannerService } from "./api-services/confirm-feature-info-by-planner.service";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { SelectionListInfo } from "./vo/selection-list-info.model";
import { TargetListInfo } from "./vo/target_list_info.model";
import { SelectionRequestInfo } from "./vo/selection-request-info.model";
import { GetGoodsPlanNumService } from "./api-services/get-goods-plan-num.service";
import { TotallingInfo } from "./vo/totalling-info.model";
import { KYMW0300Component } from "src/app/commons/kymw03/kymw0300/kymw0300.component";
import { KYMW0300InputModel } from "src/app/commons/kymw03/kymw0300/vo/kymw0300-input.model";
import { KYMW0300OutputModel } from "src/app/commons/kymw03/kymw0300/vo/kymw0300-output.model";
import { PlessViewUtils } from "src/app/shared/utils/pless-view-utils.service";
import { GetCodeListService } from "src/app/commons/kymw02/api-services/get-code-list.service";
import { FileDownloadConfirmService } from "src/app/commons/kymw02/file-download-confirm/file-download-confirm.service";
import { OrderTextWithCatalogComponent } from "src/app/commons/kymw02/text-input/order-text-with-catalog/order-text-with-catalog.component";
import { KYMW0300Model } from "src/app/commons/kymw03/kymw0300/kymw0300.model";
import { WjAccordionPane } from '@grapecity/wijmo.angular2.nav';

/**
 * 選定商品一覧タイプ
 */
enum SelectionListType {
  /** 選定商品一覧 */
  SelectionGoods = 'SelectionGoods',
  /** 商品部への選定依頼一覧 */
  SelectionRequest = 'SelectionRequest',
}

/**
 * 表紙特集掲載商品選定（CX）を管理するクラス
 *
 * @export KYMW7000Component
 * @class KYMW7000Component
 */
@Component({
  selector: "app-kymw7000",
  templateUrl: "kymw7000.component.html",
  styleUrls: ["kymw7000.component.scss"],
  encapsulation: ViewEncapsulation.None,
})

export class KYMW7000Component extends PlessViewHelperSub implements OnInit {

  private kymw0300InputVO: KYMW0300InputModel = null;		// 商品検索画面のVO
  kymw7000Model: KYMW7000Model = new KYMW7000Model();
  SelectionListType = SelectionListType; // 選定商品一覧タイプ

  /**
   * Creates an instance of KYMW7000Component.
   * @param {PlessDialogServiceSub} dialogService 
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {CheckFeatureSelectionService} checkFeatureSelectionService 
   * @param {GetSelectionRequestListService} getSelectionRequestListService 
   * @param {SaveFeatureInfoByPlannerService} saveFeatureInfoByPlannerService 
   * @param {GetTargetListByFeatureGoodsSelectionService} getTargetListByFeatureGoodsSelectionService 
   * @param {GetSelectionGoodsListService} getSelectionGoodsListService 
   * @param {GetMediumListByOrderService} getMediumListByOrderService 
   * @param {GetGoodsCoopService} getGoodsCoopService 
   * @param {GetGoodsBaseService} getGoodsBaseService 
   * @param {GetGoodsPlanNumService} getGoodsPlanNumService 
   * @param {GetFeatureThemaService} getFeatureThemaService 
   * @param {GetFeatureListService} getFeatureListService 
   * @param {GetCatalogIdService} getCatalogIdService 
   * @param {DownloadFeatureGoodsService} downloadFeatureGoodsService 
   * @param {ConfirmFeatureInfoByPlannerService} confirmFeatureInfoByPlannerService 
   * @param {Kymw00Model} kymw00Model 
   * @param {ElementRef} elementRef 
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    public viewContainerRef: ViewContainerRef,
    private checkFeatureSelectionService: CheckFeatureSelectionService,
    private getSelectionRequestListService: GetSelectionRequestListService,
    private saveFeatureInfoByPlannerService: SaveFeatureInfoByPlannerService,
    private getTargetListByFeatureGoodsSelectionService: GetTargetListByFeatureGoodsSelectionService,
    private getSelectionGoodsListService: GetSelectionGoodsListService,
    private getMediumListByOrderService: GetMediumListByOrderService,
    private getGoodsCoopService: GetGoodsCoopService,
    private getGoodsBaseService: GetGoodsBaseService,
    private getGoodsPlanNumService: GetGoodsPlanNumService,
    private getFeatureThemaService: GetFeatureThemaService,
    private getFeatureListService: GetFeatureListService,
    private downloadFeatureGoodsService: DownloadFeatureGoodsService,
    private confirmFeatureInfoByPlannerService: ConfirmFeatureInfoByPlannerService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getCodeListService: GetCodeListService,
  ) {
    super(kymw00Model);

    // 権限
    this.permission = this.getFuncPermission('KYMW7000');
  }

  @ViewChild('txt_OrderCode', { static: true }) txt_OrderCode: OrderTextWithCatalogComponent;

  // ボタン
  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;
  @ViewChild('btn_Search', { static: true }) btn_Search: ElementRef;
  @ViewChild('btn_Selection', { static: true }) btn_Selection: ElementRef;
  @ViewChild('btn_SelectionCannel', { static: true }) btn_SelectionCannel: ElementRef;
  @ViewChild('btn_Add', { static: true }) btn_Add: ElementRef;
  @ViewChild('btn_Delete', { static: true }) btn_Delete: ElementRef;
  @ViewChild('btn_Download', { static: true }) btn_Download: ElementRef;
  @ViewChild('btn_Save', { static: true }) btn_Save: ElementRef;
  @ViewChild('btn_Confirm', { static: true }) btn_Confirm: ElementRef;

  // Grid
  @ViewChild('dtg_TargetList', { static: true }) dtg_TargetList: FlexGrid;
  @ViewChild('dtg_SelectionGoodsList', { static: true }) dtg_SelectionGoodsList: FlexGrid;
  @ViewChild('dtg_SelectionRequestList', { static: true }) dtg_SelectionRequestList: FlexGrid;
  @ViewChild('dtg_Totalling', { static: true }) dtg_Totalling: FlexGrid;

  // アコーディオンタブ
  @ViewChild('wac_TargetList', { static: true }) wac_TargetList: WjAccordionPane;

  public kymw0300ComponentRef: ComponentRef<any> = null;
  public kymw0300Component: KYMW0300Component;
  public kymw0300Model: KYMW0300Model = new KYMW0300Model();

  /** 編集済みかをチェックするカウンタ */
  public editFlag: boolean = <boolean>false;

  /** ユーザ権限(0：使用不可、1：閲覧のみ、2：フルコントロール可能) */
  public permission: string = <string>'1';

  /** 特集メモ表示 */
  public featureMemoDisable: boolean = <boolean>true;

  /**
   * 編集カウントをカウントする。
   */
  public eventEditHandler(): void {
    this.editFlag = true;
  }

  /**
   * 編集カウントをクリアする。
   */
  public clearEditCount(): void {
    this.editFlag = false;
  }

  /**
   * 依頼ステータスを変換して返却する。
   * 
   * @param requestStatus 
   * @returns 
   */
  public getRequestStatusName(requestStatus: string): string {
    if (requestStatus == "0") {
      return "未依頼"
    } else {
      return "依頼済み"
    }
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW7000Component
   */
  ngOnInit(): void {
    this.kymw7000Model.FeatureList = [];

    // アコーディオン制御（全ての項目を開く）
    const detailElements = document.querySelectorAll('details.accordion')
    detailElements.forEach((item) => {
      if (item) item.setAttribute('open', 'true');
    })

    // 選定商品一覧
    this.dtg_SelectionGoodsList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_SelectionGoodsList.select(-1, -1);

      // データグリッド行の背景色設定処理
      this.setColorPattern(this.dtg_SelectionGoodsList, true);
    });
    if (this.dtg_SelectionGoodsList) {
      // チェックボックス範囲設定
      this.dtg_SelectionGoodsList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
        const ht = this.dtg_SelectionGoodsList.hitTest(e);
        if ((0 <= ht.row) && (0 == ht.col) && 
            ht.target.className !== 'wj-cell wj-header wj-align-center' &&
            !ht.target.className.includes('all-selection_list-checkbox')
          ) {
          document.getElementById(`selection_goods_list_check_${ht.row}`).click();
        }
      });
    }

    // 商品部への選定依頼一覧
    this.dtg_SelectionRequestList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_SelectionRequestList.select(-1, -1);

      // データグリッド行の背景色設定処理
      this.setColorPattern(this.dtg_SelectionRequestList, false);
    });

    if (this.dtg_SelectionRequestList) {
      // チェックボックス範囲設定
      this.dtg_SelectionRequestList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
        const ht = this.dtg_SelectionRequestList.hitTest(e);
        if ((0 <= ht.row) && (0 == ht.col) && 
            ht.target.className !== 'wj-cell wj-header wj-align-center' &&
            !ht.target.className.includes('all-request_list-checkbox')) {
          document.getElementById(`selection_request_list_check_${ht.row}`).click();
        }
      });
    }

    // 候補一覧
    this.dtg_TargetList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_TargetList.select(-1, -1);
    });
    if (this.dtg_TargetList) {
      // チェックボックス範囲設定
      this.dtg_TargetList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
        const ht = this.dtg_TargetList.hitTest(e);
        if ((0 <= ht.row) && (0 == ht.col) && 
            ht.target.className !== 'wj-cell wj-header wj-align-center' && 
            !ht.target.className.includes('all-target_list-checkbox')) {
          document.getElementById(`target_list_check_${ht.row}`).click();
        }
      });
    }

    // 集計
    this.dtg_Totalling.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_Totalling.select(-1, -1);
    });

    this.componentName = 'KYMW7000';
  }

  /**
   * 受注コード(テキストインプット)_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventOrderCode_CHANGEHandler(): void {
    this.clearDisplay();
    if (this.txt_OrderCode.isValidOrderCode()) {
      // 媒体リスト取得
      this.getMediumListByOrderService.execute(this.kymw7000Model);
    } else {
      this.kymw7000Model.MediumList = [];
      this.kymw7000Model.mediumType = '';
      this.kymw7000Model.FeatureList = [];
      this.kymw7000Model.featureCode = '';
    }
  }

  /**
   * 媒体(コンボボックス)_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventMediumType_CHANGEHandler(): void {
    if (this.kymw7000Model.mediumType === 'blankVal') this.kymw7000Model.mediumType = '';
    this.clearDisplay();
    if (this.txt_OrderCode.isValidOrderCode() && this.isValidMediumType()) {
      // 特集リスト取得
      this.getFeatureListService.execute(this.kymw7000Model);
    } else {
      this.kymw7000Model.FeatureList = [];
      this.kymw7000Model.featureCode = '';
    }
  }

  /**
   * 特集(コンボボックス)_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventFeatureType_CHANGEHandler(): void {
    if (this.kymw7000Model.featureCode === 'blankVal') this.kymw7000Model.featureCode = '';
    this.clearDisplay();
  }

  /**
   * 表示クリア
   *
   * @memberof KYMW7000Component
   */
  private clearDisplay(): void {
    this.clearEditCount();
    this.kymw7000Model.featureMemo = '';

    this.btn_Search.nativeElement.disabled = true;
    this.kymw7000Model.TargetListInfo = [];
    this.btn_Selection.nativeElement.disabled = true;
    this.kymw7000Model.targetListAll = false;
    this.btn_Add.nativeElement.disabled = true;
    this.btn_Delete.nativeElement.disabled = true;

    this.kymw7000Model.SelectionList = [];
    this.btn_SelectionCannel.nativeElement.disabled = true;
    this.kymw7000Model.selectionTotalCostPrice = null;
    this.kymw7000Model.selectionTotalPredictPlanNum = null;
    this.kymw7000Model.selectionTotalPlanNum = null;
    this.kymw7000Model.selectionTotalSupplyBudget = null;
    this.kymw7000Model.selectionTotalGpr = null;
    this.kymw7000Model.selectionListAll = false;

    this.kymw7000Model.SelectionRequestInfo = [];
    this.kymw7000Model.requestTotalCostPrice = null;
    this.kymw7000Model.requestTotalPlanNum = null;
    this.kymw7000Model.requestTotalSupplyBudget = null;
    this.kymw7000Model.requestTotalGpr = null;
    this.btn_Download.nativeElement.disabled = true;
    this.kymw7000Model.requestThisYearPlanNum = null;
    this.kymw7000Model.requestThisYearSupplyBudget = null;
    this.kymw7000Model.requestListAll = false;

    this.kymw7000Model.TotallingInfo = [];

    this.btn_Save.nativeElement.disabled = true;
    this.btn_Confirm.nativeElement.disabled = true;
  }

  /**
   * 商品部への選定依頼一覧.Pコード(テキストインプット)_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventPcode_CHANGEHandler(cell: any): void {
    this.eventEditHandler();

    // 商品名、規格名、今回供給価格、仕入価をブランクにする
    cell.item.guideGoodsName = null;
    cell.item.guideStandardName = null;
    cell.item.thisTimeSupplyPrice = null;
    cell.item.thisTimeCostPrice = null;
    // 価格パターン毎の今回供給価格と仕入価をクリア
    cell.item.supplyPriceStandard = null;
    cell.item.supplyPriceSpecial1 = null;
    cell.item.supplyPriceSpecial2 = null;
    cell.item.costPriceStandard = null;
    cell.item.costPriceSpecial1 = null;
    cell.item.costPriceSpecial2 = null;

    // 一覧更新
    this.dtg_SelectionRequestList.refresh();

    // Pコードバリデーションチェック
    if (PlessViewUtilsSub.isEmpty(cell.item.pCode)) {
      // Pコードが空の場合
      // 各種集計（GPR, 小計, 本年計画）
      this.calculateSelectionListSummary(SelectionListType.SelectionRequest, cell.item);
      return;
    } else if (!PlessViewUtilsSub.validatePCode(cell.item.pCode)) {
      // Pコードが不正な場合
      // 各種集計（GPR, 小計, 本年計画）
      this.calculateSelectionListSummary(SelectionListType.SelectionRequest, cell.item);
      // エラーダイアログ表示
      this.dialogService.openAlertGetMessage('W0024', ['Pコード']);
      return;
    }

    // 商品基本情報取得
    this.getGoodsBaseService.execute(cell.item, (data) => {
      cell.item.guideGoodsName = data.GoodsBase.GuideGoodsName;
      cell.item.guideStandardName = data.GoodsBase.GuideStandardName;
      // 商品会員生協情報取得
      this.getGoodsCoopService.execute(cell.item, 
        (data: any) => {
          // 各値に結果を挿入
          cell.item.supplyPriceStandard = data.GoodsCoop.SupplyPriceStandard;
          cell.item.supplyPriceSpecial1 = data.GoodsCoop.SupplyPriceSpecial1;
          cell.item.supplyPriceSpecial2 = data.GoodsCoop.SupplyPriceSpecial2;

          cell.item.costPriceStandard = data.GoodsCoop.CostPriceStandard;
          cell.item.costPriceSpecial1 = data.GoodsCoop.CostPriceSpecial1;
          cell.item.costPriceSpecial2 = data.GoodsCoop.CostPriceSpecial2;
          
          // 今回供給価格と仕入価を価格パターンの値によって設定
          this.setSupplyPriceAndCostPrice(cell.item);
          // 計画供給高計算
          this.calculatePlanSupplyBudget(cell.item);
          // 各種集計（GPR, 小計, 本年計画）
          this.calculateSelectionListSummary(SelectionListType.SelectionRequest, cell.item);
        }
      );
    });
  }

  /**
   * 価格パターン(セレクトボックス)_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   * @param selectionListType 選定一覧タイプ
   * @param item 一覧の各商品情報
   */
  public eventPricePettern_CHANGEHandler(selectionListType: SelectionListType, item: any): void {
    this.eventEditHandler();

    // 価格パターンがブランク値の場合は空文字に変換
    if (item.pricePattern === 'blankVal') {
      item.pricePattern = '';
    }

    // 今回供給価格と仕入価格を価格パターンの値によって設定
    this.setSupplyPriceAndCostPrice(item);

    // 計画供給高計算
    this.calculatePlanSupplyBudget(item);

    // 各種集計（GPR, 小計, 本年計画）
    this.calculateSelectionListSummary(selectionListType, item);
  }

  /**
   * 今回供給価格と仕入価を価格パターンの値によって設定
   * 
   * @memberof KYMW7000Component
   * @param item 
   */
  public setSupplyPriceAndCostPrice(item: any): void {
    // Pコードが不正な場合はブランクとする
    if (PlessViewUtilsSub.isEmpty(item.pCode) || !PlessViewUtilsSub.validatePCode(item.pCode)) {
      item.thisTimeSupplyPrice = null;
      item.thisTimeCostPrice = null;
      item.planSupplyBudget = null;
      return;
    }

    // 今回供給価格と仕入価格を反映
    if (item.pricePattern == "0") {
      // 通常の場合は通常価格を使用
      item.thisTimeSupplyPrice = item.supplyPriceStandard;
      item.thisTimeCostPrice = item.costPriceStandard;
    } else if (item.pricePattern == "1") {
      // 特1の場合は特1価格を使用
      item.thisTimeSupplyPrice = item.supplyPriceSpecial1;
      item.thisTimeCostPrice = item.costPriceSpecial1;
    } else if (item.pricePattern == "2") {
      // 特2の場合は特2価格を使用
      item.thisTimeSupplyPrice = item.supplyPriceSpecial2;
      item.thisTimeCostPrice = item.costPriceSpecial2;
    } else {
      item.thisTimeSupplyPrice = null;
      item.thisTimeCostPrice = null;
      item.planSupplyBudget = null;
    }
  }

  /**
   * 今回供給価格_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventThisTimeSupplyPrice_CHANGEHandler(selectionListType: SelectionListType, item: any): void {
    this.eventEditHandler();

    // 計画供給高計算
    this.calculatePlanSupplyBudget(item);

    // 各種集計（GPR, 小計, 本年計画）
    this.calculateSelectionListSummary(selectionListType, item);
  }

  /**
   * 仕入価_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventThisTimeCostPrice_CHANGEHandler(selectionListType: SelectionListType, item: any): void {
    this.eventEditHandler();

    // 各種集計（GPR, 小計, 本年計画）
    this.calculateSelectionListSummary(selectionListType, item);
  }

  /**
   * 計画数(修正)_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventPlanNum_CHANGEHandler(selectionListType: SelectionListType, item: any): void {
    this.eventEditHandler();

    // 計画供給高計算
    this.calculatePlanSupplyBudget(item);

    // 各種集計（GPR, 小計, 本年計画）
    this.calculateSelectionListSummary(selectionListType, item);
  }

  /**
   * 部門_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventClass_CHANGEHandler(item: any, index: number, event: any): void {
    this.eventEditHandler();

    // 集計計算
    this.calculateTotallingInfo();

    // 部門名を保持する
    const cmb = event.target as HTMLSelectElement;
    const selectName = cmb.selectedOptions[0]?.text;
    // セレクトボックスのテキストだと、コロン後にスペースがないため追加する
    this.kymw7000Model.SelectionRequestInfo[index].formatClass = selectName.replace(/:(?!\s)/g, ': ');
    // 中分類をクリアする
    this.kymw7000Model.SelectionRequestInfo[index].middleClassCode = '';
    this.kymw7000Model.SelectionRequestInfo[index].middleClassNameKanji = '';
    this.kymw7000Model.SelectionRequestInfo[index].formatMiddleClass = '';
  }

  /**
   * 中分類_変更時に呼び出される
   * 
   * @param item 
   * @param index 
   * @param event 
   * @memberof KYMW7000Component
   */
  public  eventMiddleClass_CHANGEHandler(item: any, index: number, event: any) {
    // 中分類名を保持する
    const cmb = event.target as HTMLSelectElement;
    const selectName = cmb.selectedOptions[0]?.text;
    // セレクトボックスのテキストだと、コロン後にスペースがないため追加する
    this.kymw7000Model.SelectionRequestInfo[index].formatMiddleClass = selectName.replace(/:(?!\s)/g, ': ');
  }

  /**
   * 計画供給高_変更時に呼び出される
   *
   * @memberof KYMW7000Component
   */
  public eventPlanSupplyBudget_CHANGEHandler(selectionListType: SelectionListType, item: any): void {
    this.eventEditHandler();

    // 各種集計（GPR, 小計, 本年計画）
    this.calculateSelectionListSummary(selectionListType, item);
  }

  /**
   * 選定商品一覧.全選択チェック処理
   *
   */
  public eventSelectionListAll_CLICKHandler(): void {
    const selectionList = this.kymw7000Model.SelectionList;

    if (selectionList != null) {
      selectionList.forEach((item)=> {
        if (this.kymw7000Model.selectionListAll) {
          item.check = true;
        } else {
          item.check = false;
        }
      })
      this.eventEditHandler();
      this.kymw7000Model.SelectionList = [...selectionList];
    }
  }

  /**
   * 選定商品一覧.チェック処理
   *
   */
  public eventSelectionListChk_CLICKHandler(): void {
    const selectionList = this.kymw7000Model.SelectionList;
    selectionList.forEach((item)=> {
      if (!item.check) {
        this.kymw7000Model.selectionListAll = false;
      }
    })
  }
  
  /**
   * 商品部への選定依頼一覧.全選択チェック処理
   *
   */
  public eventRequestListAll_CLICKHandler(): void {
    const list = this.kymw7000Model.SelectionRequestInfo;

    if (list != null) {
      list.forEach((item)=> {
        if (this.kymw7000Model.requestListAll) {
          item.check = true;
        } else {
          item.check = false;
        }
      })
      this.eventEditHandler();
      this.kymw7000Model.SelectionRequestInfo = [...list];
    }
  }

  /**
   * 商品部への選定依頼一覧.チェック処理
   *
   */
  public eventRequestListChk_CLICKHandler(): void {
    const list = this.kymw7000Model.SelectionRequestInfo;
    list.forEach((item)=> {
      if (!item.check) {
        this.kymw7000Model.requestListAll = false;
      }
    })
  }

  /**
   * 候補一覧.全選択チェック処理
   *
   */
  // TOOD: 非活性(選定済み商品)のチェックは外す
  public eventTagetListAll_CLICKHandler(): void {
    const list = this.kymw7000Model.TargetListInfo;

    if (list != null) {
      list.forEach((item)=> {
        if (this.kymw7000Model.targetListAll) {
          item.check = true;
        } else {
          item.check = false;
        }
      })
      this.eventEditHandler();
      this.kymw7000Model.TargetListInfo = [...list];
    }
  }

  /**
   * 候補一覧.チェック処理
   *
   */
  public eventTargetListChk_CLICKHandler(): void {
    const list = this.kymw7000Model.TargetListInfo;
    list.forEach((item)=> {
      if (!item.check) {
        this.kymw7000Model.targetListAll = false;
      }
    })
  }

  /**
   * ボタン押下 表示
   *
   * @memberof KYMW7000Component
   */
  public eventDisplay_CLICKHandler() {
    // バリデーション 必須チェック
    if (this.kymw7000Model.catalogId === '') {
      this.dialogService.openAlertGetMessage('W0001', ['企画回']);
      return;
    }
    if (!this.isValidMediumType()) {
      this.dialogService.openAlertGetMessage('W0001', ['媒体']);
      return;
    }
    
    // 価格パターンリスト取得
    this.getCodeListService.execute("ct355", "", this.kymw7000Model, "PricePetternList", () => {

      const loginBuyerList = [];
      if (!this.isValidFeatureCode()) {
        // 表紙特集選定商品一覧取得
        this.getSelectionGoodsListService.execute(this.kymw7000Model, loginBuyerList, 
          (data) => this.successGetSelectionGoodsList(data));
        this.kymw7000Model.featureMemo = '';
        this.featureMemoDisable = false;
      } else {
        // 特集情報取得
        this.getFeatureThemaService.execute(this.kymw7000Model, () => {
          // 表紙特集選定商品一覧取得
          this.getSelectionGoodsListService.execute(this.kymw7000Model, loginBuyerList, 
            (data) => this.successGetSelectionGoodsList(data));
        });
        this.featureMemoDisable = true;
      }
    });
  }

  /**
   * 表紙特集選定商品一覧取得成功時処理
   * 
   */
  successGetSelectionGoodsList(data: GetSelectionGoodsListResponse) {
    const updateList = [];
    data.SelectionList.map(item => {
      const addData = new SelectionListInfo();
      addData.check = false;
      addData.featureCode = item.FeatureCode;
      addData.featureName = item.FeatureName;
      addData.formatFeature = this.formatCodeName(item.FeatureCode, item.FeatureName);
      addData.classCode = item.ClassCode;
      addData.classNameKanji = item.ClassName;
      addData.formatClass = this.formatCodeName(item.ClassCode, item.ClassName);
      addData.middleClassCode = item.MiddleClassCode;
      addData.middleClassNameKanji = item.MiddleClassName;
      addData.formatMiddleClass = this.formatCodeName(item.MiddleClassCode, item.MiddleClassName);
      addData.pCode = item.PCode;
      addData.guideGoodsName = item.GuideGoodsName;
      addData.guideStandardName = item.GuideStandardName;
      addData.pricePattern = item.PricePattern;
      addData.isChangedPricePattern = item.IsChangedPricePattern;
      addData.thisTimeSupplyPrice = item.ThisTimeSupplyPrice;
      addData.supplyPriceStandard = item.SupplyPriceStandard;
      addData.supplyPriceSpecial1 = item.SupplyPriceSpecial1;
      addData.supplyPriceSpecial2 = item.SupplyPriceSpecial2;
      addData.isChangedSupplyPrice = item.IsChangedSupplyPrice;
      addData.thisTimeCostPrice = item.ThisTimeCostPrice;
      addData.costPriceStandard = item.CostPriceStandard;
      addData.costPriceSpecial1 = item.CostPriceSpecial1;
      addData.costPriceSpecial2 = item.CostPriceSpecial2;
      addData.isChangedCostPrice = item.IsChangedCostPrice;
      addData.predictPlanNum = item.PredictPlanNum;
      addData.planNum = item.PlanNum;
      addData.isChangedPlanNum = item.IsChangedPlanNum;
      addData.planSupplyBudget = item.PlanSupplyBudget;
      addData.isChangedPlanSupplyBudget = item.IsChangedPlanSupplyBudget;
      addData.gpr = 
        this.calculateGPR(item.PlanSupplyBudget, item.PredictPlanNum, item.PlanNum, item.ThisTimeCostPrice);
      addData.tagName = item.TagName;
      addData.remarks = item.Remarks;
      addData.selectorType = item.SelectorType;
      addData.buyerRequestId = item.BuyerRequestId;
      addData.itemCode = item.ItemCode;
      addData.buyerApprovalFlag = item.BuyerApprovalFlag;
      updateList.push(addData)
    })
    this.kymw7000Model.SelectionList = updateList;

    // 全選択のチェックを外す
    this.kymw7000Model.selectionListAll = false;

    this.dtg_SelectionGoodsList.refresh();

    // 表紙特集選定依頼一覧取得
    this.getSelectionRequestListService.execute(this.kymw7000Model, 
      (data) => this.successGetSelectionRequestList(data)
    );
  }

  /**
   * コードと名称の整形処理
   * 
   * @param code 
   * @param name 
   * @returns code: name
   */
  public formatCodeName(code: string, name: string) {
    if (!PlessViewUtils.isEmpty(code) && !PlessViewUtils.isEmpty(name)) {
      return code + ": " + name
    }
  }

  /**
   * 表紙特集選定依頼一覧取得成功時処理
   * 
   */
  successGetSelectionRequestList(data: GetSelectionRequestListResponse) {
    const updateList = [];
    data.FeatureRequestList.map(item => {
      const addData = new SelectionRequestInfo();
      addData.buyerRequestId = item.BuyerRequestId;
      addData.featureCode = item.FeatureCode;
      addData.featureName = item.FeatureName;
      addData.formatFeature = this.formatCodeName(item.FeatureCode, item.FeatureName);
      addData.classCode = item.ClassCode;
      addData.classNameKanji = item.ClassName;
      addData.formatClass = this.formatCodeName(item.ClassCode, item.ClassName);
      addData.middleClassCode = item.MiddleClassCode;
      addData.middleClassNameKanji = item.MiddleClassName;
      addData.formatMiddleClass = this.formatCodeName(item.MiddleClassCode, item.MiddleClassName);
      addData.pCode = item.PCode;
      addData.guideGoodsName = item.GuideGoodsName;
      addData.guideStandardName = item.GuideStandardName;
      addData.pricePattern = item.PricePattern;
      addData.thisTimeSupplyPrice = item.ThisTimeSupplyPrice;
      addData.supplyPriceStandard = item.SupplyPriceStandard;
      addData.supplyPriceSpecial1 = item.SupplyPriceSpecial1;
      addData.supplyPriceSpecial2 = item.SupplyPriceSpecial2;
      addData.thisTimeCostPrice = item.ThisTimeCostPrice;
      addData.costPriceStandard = item.CostPriceStandard;
      addData.costPriceSpecial1 = item.CostPriceSpecial1;
      addData.costPriceSpecial2 = item.CostPriceSpecial2;
      addData.planNum = item.PlanNum;
      addData.planSupplyBudget = item.PlanSupplyBudget;
      addData.gpr = 
        this.calculateGPR(item.PlanSupplyBudget, null, item.PlanNum, item.ThisTimeCostPrice);
      addData.requestStatus = item.RequestStatus;
      addData.requestStatusName = this.getRequestStatusName(item.RequestStatus);
      addData.remarks = item.Remarks;
      updateList.push(addData)
    })
    this.kymw7000Model.SelectionRequestInfo = updateList;

    this.successDisplay()
  }

  /**
   * 表示成功時処理
   * 
   */
  public successDisplay() {
    // 全選択のチェックを外す
    this.kymw7000Model.requestListAll = false;

    // 集計計算
    this.calculateTotallingInfo();

    // 選定商品一覧.小計計算
    this.calculateSubTotallingSelection(this.kymw7000Model.SelectionList);

    // 選定依頼一覧.小計計算
    this.calculateSubTotallingRequest(this.kymw7000Model.SelectionRequestInfo);

    // 本年計画計算
    this.calculateThisYearPlan();

    this.dtg_SelectionGoodsList.invalidate();
  
    // 活性制御
    if(!PlessViewUtilsSub.isEmpty(this.kymw7000Model.featureCode) && this.kymw7000Model.plannerSelectionFlag != "1") {
      // 登録モード
      this.enableMode(false);
    } else if(PlessViewUtilsSub.isEmpty(this.kymw7000Model.featureCode) || this.kymw7000Model.plannerSelectionFlag == "1") {
      // 閲覧モード
      this.enableMode(true);
    }
  }

  /**
   * 活性制御
   * @param mode true: 閲覧、false: 登録
   */
  public enableMode(mode: boolean): void  {
    // フルコントロールの場合
    if(this.permission == "2") {
      this.btn_Search.nativeElement.disabled = mode;
      this.btn_Selection.nativeElement.disabled = mode;
      this.btn_SelectionCannel.nativeElement.disabled = mode;
      this.btn_Add.nativeElement.disabled = mode;
      this.btn_Delete.nativeElement.disabled = mode;
      this.btn_Save.nativeElement.disabled = mode;
      this.btn_Confirm.nativeElement.disabled = mode;  
    }

    if (this.kymw7000Model.approvalFlowType == "2") {
      // 承認フロー区分が「2:バイヤー直承認」の場合、確定ボタンを非活性
      this.btn_Confirm.nativeElement.disabled = true;
    }

    this.btn_Download.nativeElement.disabled = false;

    // アコーディオン制御（候補一覧）
    // 特集コードを入力していない場合、または、企画担当商品選定済フラグが「1:選定済み」の場合 アコーディオン：閉
    if (mode) {
      this.wac_TargetList.isCollapsed = true;
    } else {
      // 特集コードを入力している場合、かつ、企画担当商品選定済フラグが「0:選定未完了」の場合 アコーディオン：開
      this.wac_TargetList.isCollapsed = false;
    }
  }

  /**
   * データグリッド行の背景色設定
   * @param grid 
   * @param mode true: 選定商品一覧、false: 選定依頼一覧
   */
  public setColorPattern(grid: FlexGrid, mode: boolean): void {
    // 背景色設定
    if (mode) {
      // 選定商品一覧
      grid.rows.forEach((row) => {
        if (row.dataItem.selectorType === '1') {
          row.cssClass = 'grid-row-selection-done';
        } else if (row.dataItem.selectorType === '2' && !PlessViewUtilsSub.isEmpty(row.dataItem.buyerRequestId)) {
          row.cssClass = 'grid-row-buyer-selection';
        } else if (row.dataItem.selectorType === '2' && PlessViewUtilsSub.isEmpty(row.dataItem.buyerRequestId)) {
          row.cssClass = 'grid-row-replace-selection ';
        } else if (row.dataItem.buyerApprovalFlag === '2') {
          row.cssClass = 'grid-row-rejection';
        }
      });
    } else {
      // 選定依頼一覧
      grid.rows.forEach((row) => {
        if (row.dataItem.requestStatus === '2') {
          row.cssClass = 'grid-row-rejection';
        }
      })
    }
  }
  
  /**
   * ボタン押下 商品検索
   *
   * @memberof KYMW7000Component
   */
  public eventSeach_CLICKHandler() {
    this.eventEditHandler();
    if (this.kymw0300InputVO === null) {
      this.kymw0300InputVO = new KYMW0300InputModel();
    }
    // 企画関連条件を表示する（企画検索フラグ:1）
    this.kymw0300InputVO.catalogSearchFlg = 1;
    
    // 商品検索画面(モーダレス)を表示する。
    this.kymw0300ComponentRef =
      this.dialogService.openModelessSub(
        this, KYMW0300Component,
        this.viewContainerRef, this.kymw0300ComponentRef, null, 0, '', true
      );

    if (this.kymw0300ComponentRef != null) {
      this.kymw0300Component = this.kymw0300ComponentRef.instance as KYMW0300Component;
      this.kymw0300Component.parent = this;
      this.kymw0300Component.setInterfaceParam(this.kymw0300InputVO);
      this.kymw0300Component.setKYMW0300Parameter =
        (outputVO: KYMW0300OutputModel) => {
          this.kymw0300InputVO = this.kymw0300Model.getKYMW0300SearchHistory(outputVO);
          this.getTargetListByFeatureGoodsSelectionService.execute(this.kymw7000Model, outputVO, 
            (data: GetTargetListByFeatureGoodsSelectionResponse) => this.successGetTargetList(data)
          );
        };
      // ウィンドウが閉じられる際の処理
      this.kymw0300Component.closeFunction = () => {
        this.kymw0300ComponentRef.destroy();
      };
    }
  }

  /**
   * 商品検索処理成功時
   * @param data 
   */
  public successGetTargetList(list: GetTargetListByFeatureGoodsSelectionResponse) {
    const updateList = [];
    list.map(item => {
      const addData = new TargetListInfo();
      addData.checkFlag = false;
      addData.check = false;
      addData.pCode = item.PCode;
      addData.itemCode = item.ItemCode;
      addData.guideGoodsName = item.GuideGoodsName;
      addData.guideStandardName = item.GuideStandardName;
      addData.classCode = item.ClassCode;
      addData.classNameKanji = item.ClassNameKanji;
      addData.formatClass = this.formatCodeName(item.ClassCode, item.ClassNameKanji);
      addData.largeClassCode = item.LargeClassCode;
      addData.largeClassNameKanji = item.LargeClassNameKanji;
      addData.formatLargeClass = this.formatCodeName(item.LargeClassCode, item.LargeClassNameKanji);
      addData.middleClassCode = item.MiddleClassCode;
      addData.middleClassNameKanji = item.MiddleClassNameKanji;
      addData.formatMiddleClass = this.formatCodeName(item.MiddleClassCode, item.MiddleClassNameKanji);
      addData.smallClassCode = item.SmallClassCode;
      addData.smallClassNameKanji = item.SmallClassNameKanji;
      addData.formatSmallClass = this.formatCodeName(item.SmallClassCode, item.SmallClassNameKanji);
      addData.tagName = item.TagName;
      addData.supplyPriceStandard = item.SupplyPriceStandard;
      addData.supplyPriceSpecial1 = item.SupplyPriceSpecial1;
      addData.supplyPriceSpecial2 = item.SupplyPriceSpecial2;
      addData.costPriceStandard = item.CostPriceStandard;
      addData.costPriceSpecial1 = item.CostPriceSpecial1;
      addData.costPriceSpecial2 = item.CostPriceSpecial2;
      updateList.push(addData)
    })
    this.kymw7000Model.TargetListInfo = updateList;

    // 全選択チェックを外す
    this.kymw7000Model.targetListAll = false;
  }

  /**
   * ボタン押下 選定
   *
   * @memberof KYMW7000Component
   */
  public eventSelection_CLICKHandler() {
    this.eventEditHandler();
    let checkTargetListInfo = this.kymw7000Model.TargetListInfo.filter(_ => _.check);

    // 商品選択チェックにチェックなしでボタン操作した際、何も動作しない
    // チェックした商品が一つでもある場合は処理を続行
    if(!PlessViewUtilsSub.isEmptyArray(checkTargetListInfo)) {
      // 取扱終了チェック
      let normalPcode = []
      this.checkFeatureSelectionService.execute(this.kymw7000Model,
        (data: any) => {
          normalPcode = data.NormalPCodeList;
          if (normalPcode.length !== checkTargetListInfo.length) {
            this.dialogService.openAlertGetMessage("I0524");
          }
          // 取扱終了しているデータを削除する
          checkTargetListInfo = 
            checkTargetListInfo.filter(item => normalPcode.some(obj => obj.PCode === item.pCode));
          // 既に選定商品一覧に存在しているデータを削除
          checkTargetListInfo = 
            checkTargetListInfo.filter(item => !this.kymw7000Model.SelectionList.some(obj => obj.pCode === item.pCode));
          // 商品計画数予測取得
          this.getGoodsPlanNumService.execute(this.kymw7000Model, checkTargetListInfo, 
            (data: any) => this.successGetGoodsPlanNum(data,checkTargetListInfo)
          );
        }
      );
    }
  }
  
  /**
   * 商品計画数予測取得成功時処理
   * 
   * @param data 
   * @param checkTargetListInfo 
   */
  private successGetGoodsPlanNum(data: any, checkTargetListInfo: TargetListInfo[]) {
    let goodsPlanNum = []
    goodsPlanNum = data.PlanNumList;
    // 特集名取得
    const featureElement = document.getElementById("cmb_FeatureType")
    const selectElement = featureElement.firstElementChild as HTMLSelectElement;
    const featureText = selectElement.options[selectElement.selectedIndex].text
    const featureName = featureText.split(/:(.*)/).slice(0, 2);

    const updateSelectionList: SelectionListInfo[] = [...this.kymw7000Model.SelectionList]
    const addPcodeList = [];
    // 計画数(予測)を設定
    checkTargetListInfo.forEach((updateItem) => {
      const match = goodsPlanNum.find(planNum => planNum.PCode === updateItem.pCode);

      const addSelectionList = new SelectionListInfo();
      addSelectionList.featureCode = this.kymw7000Model.featureCode;
      addSelectionList.featureName = featureName[1];
      addSelectionList.formatFeature = this.formatCodeName(this.kymw7000Model.featureCode, featureName[1]);
      addSelectionList.classCode = updateItem.classCode;
      addSelectionList.classNameKanji = updateItem.classNameKanji;
      addSelectionList.formatClass = this.formatCodeName(updateItem.classCode, updateItem.classNameKanji);
      addSelectionList.middleClassCode = updateItem.middleClassCode;
      addSelectionList.middleClassNameKanji = updateItem.middleClassNameKanji;
      addSelectionList.formatMiddleClass = this.formatCodeName(updateItem.middleClassCode, updateItem.middleClassNameKanji);
      addSelectionList.pCode = updateItem.pCode;
      addSelectionList.guideGoodsName = updateItem.guideGoodsName;
      addSelectionList.guideStandardName = updateItem.guideStandardName;
      addSelectionList.predictPlanNum = match == undefined ? null : match.PlanNumAiPrediction;
      addSelectionList.tagName = updateItem.tagName;
      addSelectionList.itemCode = updateItem.itemCode;
      addSelectionList.supplyPriceStandard = updateItem.supplyPriceStandard;
      addSelectionList.supplyPriceSpecial1 = updateItem.supplyPriceSpecial1;
      addSelectionList.supplyPriceSpecial2 = updateItem.supplyPriceSpecial2;
      addSelectionList.costPriceStandard = updateItem.costPriceStandard;
      addSelectionList.costPriceSpecial1 = updateItem.costPriceSpecial1;
      addSelectionList.costPriceSpecial2 = updateItem.costPriceSpecial2;
      
      updateSelectionList.push(addSelectionList)
      addPcodeList.push(updateItem.pCode)
    })

    this.kymw7000Model.SelectionList = updateSelectionList;

    // 小計計算
    this.calculateSubTotallingSelection(this.kymw7000Model.SelectionList);

    // 集計計算
    this.calculateTotallingInfo();

    // 本年計画計算
    this.calculateThisYearPlan();
  }

  /**
   * ボタン押下 選定解除
   *
   * @memberof KYMW7000Component
   */
  public eventSelectionCannel_CLICKHandler() {
    this.eventEditHandler();
    
    // 選択した行を削除する
    this.kymw7000Model.SelectionList = this.kymw7000Model.SelectionList.filter(_ => !_.check);

    // 全選択チェックを外す
    this.kymw7000Model.selectionListAll = false;

    // 選定商品一覧.小計計算
    this.calculateSubTotallingSelection(this.kymw7000Model.SelectionList);

    // 本年計画計算
    this.calculateThisYearPlan();

    // 集計計算
    this.calculateTotallingInfo();
  }

  /**
   * ボタン押下 追加
   *
   * @memberof KYMW7000Component
   */
  public eventAdd_CLICKHandler() {
    this.eventEditHandler();

    // 特集名取得
    const featureElement = document.getElementById("cmb_FeatureType")
    const selectElement = featureElement.firstElementChild as HTMLSelectElement;
    const featureText = selectElement.options[selectElement.selectedIndex].text
    const featureName = featureText.split(/:(.*)/).slice(0, 2);

    // 商品部への選定依頼一覧に空行を追加
    const addList = new SelectionRequestInfo();
    addList.check = false;
    addList.featureCode = this.kymw7000Model.featureCode;
    addList.featureName = featureName[1];
    addList.formatFeature = this.formatCodeName(this.kymw7000Model.featureCode, featureName[1]);
    addList.pricePattern = "0";
    addList.requestStatus = "0";
    addList.requestStatusName = this.getRequestStatusName("0");

    const updateSelectionRequestInfo = [...this.kymw7000Model.SelectionRequestInfo,addList];
    this.kymw7000Model.SelectionRequestInfo = updateSelectionRequestInfo;

    this.dtg_SelectionRequestList.refresh();
  }

  /**
   * ボタン押下 削除
   *
   * @memberof KYMW7000Component
   */
  public eventDelete_CLICKHandler() {
    this.eventEditHandler();

    const infoList = this.kymw7000Model.SelectionRequestInfo;
    const deleteInfo = new Array();   // 削除する行
    const keepInfo = new Array();     // 削除しない行

    // 選択状態の判定
    for (let i = Number(0); i < infoList.length; i++ ) {
      if (infoList[i].check) {
        // 依頼済みデータの場合、エラー
        if (infoList[i].requestStatus !== '0') {
          this.dialogService.openAlertGetMessage('E0513', ['依頼済みデータを含む', '削除']);
          return;
        }
        deleteInfo.push(infoList[i]);
      } else {
        keepInfo.push(infoList[i]);
      }
    }

    // 選択行がある場合
    if (!PlessViewUtilsSub.isEmptyArray(deleteInfo)) {
      // 選択した行を削除する
      this.dialogService.openAlertGetMessage(
        'Q0106', ['選択した行'],
          (closeDetail: any): void => {
            if (closeDetail === PlessAlert.Yes) {
              // 選択した行を削除する
              this.kymw7000Model.SelectionRequestInfo = keepInfo;
              // ヘッダーチェックでの全選択の場合チェックを外す
              this.kymw7000Model.requestListAll = false;              
              // 選定依頼一覧.小計計算
              this.calculateSubTotallingRequest(this.kymw7000Model.SelectionRequestInfo);
              // 本年計画計算
              this.calculateThisYearPlan();
              // 集計計算
              this.calculateTotallingInfo();
            }
          }
      )
    }    
  }

  /**
   * ボタン押下 ダウンロード
   *
   * @memberof KYMW7000Component
   */
  public eventDownload_CLICKHandler() {
    this.eventEditHandler();

    // 媒体名取得
    const mediumElement = document.getElementById("cmb_MediumType");
    const selectElement = mediumElement.firstElementChild as HTMLSelectElement;
    const mediumText = selectElement.options[selectElement.selectedIndex].text;
    const mediumName = mediumText.split(':'); 
    
    const downloadList: any[] = [];
    this.kymw7000Model.SelectionList.forEach(item => {
      let planNum = item.planNum;
      if (PlessViewUtilsSub.isEmpty(item.planNum)) {
        planNum = item.predictPlanNum;
      }

      let pricePattern = "";
      if (item.pricePattern == "0") {
        pricePattern = "通常価";
      } else if (item.pricePattern == "1") {
        pricePattern = "特価1";
      } else if (item.pricePattern == "2") {
        pricePattern = "特価2";
      } else if (item.pricePattern == "3") {
        pricePattern = "特価3";
      }

      let selector = "";
      if (item.selectorType == "0") {
        selector = "-";
      } else if (item.selectorType == "1") {
        selector = "企画支援";
      } else if (item.selectorType == "2") {
        selector = "バイヤー";
      } else if (item.selectorType == "3") {
        selector = "サプライヤー";
      }

      const addItem = {
        CatalogId: this.kymw7000Model.catalogId,
        MediumName: mediumName[1],
        Feature: item.featureCode + ": " + item.featureName,
        ClassName: item.classCode + ": " + item.classNameKanji,
        MiddleClass: item.middleClassCode + ": " + item.middleClassNameKanji,
        PCode: item.pCode,
        GuideGoodsName: item.guideGoodsName,
        GuideStandardName: item.guideStandardName,
        PricePattern: pricePattern,
        ThisTimeSupplyPrice: item.thisTimeSupplyPrice,
        ThisTimeCostPrice: item.thisTimeCostPrice,
        PredictPlanNum: item.predictPlanNum,
        PlanNum: planNum,
        PlanSupplyBudget: item.planSupplyBudget,
        GPR: item.gpr,
        TagName: item.tagName,
        Status: "-",
        Selector: selector,
        Remarks: item.remarks,
      }
      downloadList.push(addItem)
    })

    this.kymw7000Model.SelectionRequestInfo.forEach((item) => {
      let classText = '';
      if (item.classCode) {
        if (item.formatClass) {
          classText = item.formatClass;
        } else {
          classText = this.formatCodeName(item.classCode, item.classNameKanji) ?? '';
        }
      }

      let middleClassText = '';
      if (item.middleClassCode) {
        if (item.formatMiddleClass) {
          middleClassText = item.formatMiddleClass
        } else {
          middleClassText = this.formatCodeName(item.middleClassCode, item.middleClassNameKanji) ?? '';
        }
      }

      let pricePattern = "";
      if (item.pricePattern == "0") {
        pricePattern = "通常価";
      } else if (item.pricePattern == "1") {
        pricePattern = "特価1";
      } else if (item.pricePattern == "2") {
        pricePattern = "特価2";
      } else if (item.pricePattern == "3") {
        pricePattern = "特価3";
      }

      const addItem = {
        CatalogId: this.kymw7000Model.catalogId,
        MediumName: mediumName[1],
        Feature: item.featureCode + ": " + item.featureName,
        ClassName: classText,
        MiddleClass: middleClassText,
        PCode: item.pCode,
        GuideGoodsName: item.guideGoodsName,
        GuideStandardName: item.guideStandardName,
        PricePattern: pricePattern,
        ThisTimeSupplyPrice: item.thisTimeSupplyPrice,
        ThisTimeCostPrice: item.thisTimeCostPrice,
        PredictPlanNum: null,
        PlanNum: item.planNum,
        PlanSupplyBudget: item.planSupplyBudget,
        GPR: item.gpr,
        TagName: null,
        Status: item.requestStatusName,
        Selector: "バイヤー",
        Remarks: item.remarks,
      }
      downloadList.push(addItem)
    })

    this.downloadFeatureGoodsService.execute(downloadList, (data: any) => {
      // ダウンロード処理
      this.fileDownloadConfirmService.show(data.FilePath, data.FileName);
    });
  }

  /**
   * ボタン押下 確定
   *
   * @memberof KYMW7000Component
   */
  public eventConfirm_CLICKHandler() {
    this.eventEditHandler();
    if (this.validate()) {
      this.dialogService.openAlertGetMessage(
        'Q0162', [],
          (closeDetail: any): void => {
            if (closeDetail === PlessAlert.Yes) {
              this.confirmFeatureInfoByPlannerService.execute(this.kymw7000Model, 
                () => this.enableMode(true));
            }
          }
      )
    }
  }

  /**
   * ボタン押下 一時保存
   *
   * @memberof KYMW7000Component
   */
  public eventSave_CLICKHandler() {
    this.eventEditHandler();
    if (this.validate()) {
      this.dialogService.openAlertGetMessage(
        'Q0105', ['表紙特集商品選定情報'],
        (closeDetail: any): void => {
          if (closeDetail === PlessAlert.Yes) {
            this.saveFeatureInfoByPlannerService.execute(this.kymw7000Model);
          }
        }
      )
    }
  }

  /**
   * 確定、一時保存時のバリデート
   */
  public validate(): boolean {
    // バリデーション 検索条件エリア
    let resVal = true;
    // 必須チェック
    if (this.kymw7000Model.orderCode === '') {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
      return false;
    }
    if (!this.isValidMediumType()) {
      this.dialogService.openAlertGetMessage('W0001', ['媒体']);
      return false;
    }
    if (!this.isValidFeatureCode()) {
      this.dialogService.openAlertGetMessage('W0001', ['特集']);
      return false;
    }
    // 桁数チェック
    if (!this.isMaxLength(this.kymw7000Model.featureMemo, 500)) {
      this.dialogService.openAlertGetMessage('W0007', ['備考','500']);
      return false;
    }

    // バリデーション 選定商品エリア
    for ( const item of this.kymw7000Model.SelectionList) {
      // 必須チェック
      if (!item.pricePattern) {
        this.dialogService.openAlertGetMessage('W0001', ['価格パターン']);
        return resVal = false;
      }
      if (!item.thisTimeSupplyPrice) {
        this.dialogService.openAlertGetMessage('W0001', ['今回供給価格']);
        return resVal = false;
      }
      if (!item.thisTimeCostPrice) {
        this.dialogService.openAlertGetMessage('W0001', ['仕入価']);
        return resVal = false;
      }
      if (!item.planSupplyBudget) {
        this.dialogService.openAlertGetMessage('W0001', ['計画供給高']);
        return resVal = false;
      }
      // フォーマットチェック
      if (this.isNaNString(item.thisTimeSupplyPrice)) {
        this.dialogService.openAlertGetMessage('W0024', ['今回供給価格']);
        return resVal = false;
      }
      if (this.isNaNString(item.thisTimeCostPrice)) {
        this.dialogService.openAlertGetMessage('W0024', ['仕入価']);
        return resVal = false;
      }
      if (this.isNaNString(item.planNum)) {
        this.dialogService.openAlertGetMessage('W0024', ['計画数(修正)']);
        return resVal = false;
      }
      if (this.isNaNString(item.planSupplyBudget)) {
        this.dialogService.openAlertGetMessage('W0024', ['計画供給高']);
        return resVal = false;
      }
      // 桁数チェック
      if (!this.isMaxLength(item.thisTimeSupplyPrice, 7)) {
        this.dialogService.openAlertGetMessage('W0007', ['今回供給価格','7']);
        return resVal = false;
      }
      const tmp = item.thisTimeCostPrice.split('.');
      if (tmp[0].length > 7) {
        // 整数部のチェック
        this.dialogService.openAlertGetMessage('W0015', ['仕入価','7', '2']);
        return resVal = false;
      }
      if (tmp.length > 1 && tmp[1].length > 2) {
        // 小数部のチェック
        this.dialogService.openAlertGetMessage('W0015', ['仕入価','7', '2']);
        return resVal = false;
      }
      if (!this.isMaxLength(item.planNum, 7)) {
        this.dialogService.openAlertGetMessage('W0007', ['計画数(修正)', '7']);
        return resVal = false;
      }
      if (!this.isMaxLength(item.planSupplyBudget, 11)) {
        this.dialogService.openAlertGetMessage('W0007', ['計画供給高', '11']);
        return resVal = false;
      }
      if (!this.isMaxLength(item.planSupplyBudget, 100)) {
        this.dialogService.openAlertGetMessage('W0007', ['備考', '100']);
        return resVal = false;
      }
    }

    // バリデーション 商品部への選定依頼一覧
    for ( const item of this.kymw7000Model.SelectionRequestInfo) {
      // 必須チェック
      if (!item.classCode) {
        this.dialogService.openAlertGetMessage('W0001', ['部門']);
        return resVal = false;
      }
      if (!item.planSupplyBudget) {
        this.dialogService.openAlertGetMessage('W0001', ['計画供給高']);
        return resVal = false;
      }
      // フォーマットチェック
      if (this.isNaNString(item.planSupplyBudget)) {
        this.dialogService.openAlertGetMessage('W0024', ['計画供給高']);
        return resVal = false;
      }
      if (this.isNaNString(item.planNum)) {
        this.dialogService.openAlertGetMessage('W0024', ['計画数']);
        return resVal = false;
      }
      // Pコード
      if (!PlessViewUtilsSub.isEmpty(item.pCode)) {
        if (!PlessViewUtilsSub.validatePCode(item.pCode)) {
          this.dialogService.openAlertGetMessage('W0024', ['Pコード']);
          return resVal = false;
        }
      }
      // 桁数チェック
      if (!this.isMaxLength(item.planSupplyBudget, 11)) {
        this.dialogService.openAlertGetMessage('W0007', ['計画供給高', '11']);
        return resVal = false;
      }
      if (!this.isMaxLength(item.planNum, 7)) {
        this.dialogService.openAlertGetMessage('W0007', ['計画数', '7']);
        return resVal = false;
      }
      if (!this.isMaxLength(item.planSupplyBudget, 100)) {
        this.dialogService.openAlertGetMessage('W0007', ['備考', '100']);
        return resVal = false;
      }
    }
    return resVal;
  }

  /**
   * GPR計算
   * (計画供給高 -（計画数 * 仕入価)) / 計画供給高 で計算。
   * @param planSupplyBudget 
   * @param predictPlanNum
   * @param planNum 
   * @param thisTimeCostPrice 
   * @param totalPlanNumCostPrice 小計の計算用　各商品の（計画数(修正) * 仕入価）の結果を合算
   */
  public calculateGPR(planSupplyBudget: string, predictPlanNum: string, planNum: string, thisTimeCostPrice: string, totalPlanNumCostPrice?: string): string {
    if (
      PlessViewUtilsSub.isEmpty(planSupplyBudget) ||
      PlessViewUtilsSub.isEmpty(thisTimeCostPrice) ||
      (PlessViewUtilsSub.isEmpty(predictPlanNum) && PlessViewUtilsSub.isEmpty(planNum))
    ) {
      // 必要項目が未入力
      return null;
    }
  
    // 計画供給高
    const numPlanSupplyBudget = this.convertStrToNum(planSupplyBudget);
    // 計画供給高が0の場合は0を返す(0割り対策)
    if (numPlanSupplyBudget === 0) {
      return "0.0";
    }

    // 計画数
    let numPlanNum = 0;
    if (!PlessViewUtilsSub.isEmpty(planNum)) {
      // 計画数(修正)が入力されている場合
      numPlanNum = this.convertStrToNum(planNum);
    } else {
      // 計画数(予測)が入力されている場合
      numPlanNum = this.convertStrToNum(predictPlanNum);
    }

    // GPR計算(小数第一位まで)
    let gpr = 0;
    if (totalPlanNumCostPrice) {
      // 小計GPR計算用
      const numTotalPlanNumCostPrice = this.convertStrToNum(totalPlanNumCostPrice);
      gpr = (numPlanSupplyBudget - numTotalPlanNumCostPrice) / numPlanSupplyBudget * 100;
    } else {
      // 仕入価
      const numThisTimeCostPrice = this.convertStrToNum(thisTimeCostPrice);
      gpr = (numPlanSupplyBudget - (numPlanNum * numThisTimeCostPrice)) / numPlanSupplyBudget * 100;
    }

    gpr = (Math.round(gpr * 10) / 10);

    return gpr.toFixed(1);
  }

  /**
   * 集計計算
   * @param list 
   * @param classname 
   * @returns 
   */
  public calculateTotalling(list: any, classname: string): TotallingInfo {
    let farmProduct = 0;
    let marineProduct = 0;
    let animalProduct = 0;
    let dailyDelivery = 0;
    let sweets = 0;
    let food = 0;
    let liveCategory = 0;
    let processedMeat = 0;
    let bread = 0;
    let alcohol = 0;
    let rice = 0;
    let eggAndMilk = 0;
    let freezedAndIce = 0;
    let deliFoods = 0;
    
    list.forEach((item: { classCode: string; }) => {
      if(item.classCode == "01") {
        farmProduct += 1;
      } else if(item.classCode == "02") {
        marineProduct += 1;
      } else if(item.classCode == "03") {
        animalProduct += 1;
      } else if(item.classCode == "04") {
        dailyDelivery += 1;
      } else if(item.classCode == "05") {
        sweets += 1;
      } else if(item.classCode == "06") {
        food += 1;
      } else if(item.classCode == "07") {
        liveCategory += 1;
      } else if(item.classCode == "08") {
        processedMeat += 1;
      } else if(item.classCode == "09") {
        bread += 1;
      } else if(item.classCode == "10") {
        alcohol += 1;
      } else if(item.classCode == "11") {
        rice += 1;
      } else if(item.classCode == "14") {
        eggAndMilk += 1;
      } else if(item.classCode == "15") {
        freezedAndIce += 1;
      } else if(item.classCode == "16") {
        deliFoods += 1;
      }
    })

    return new TotallingInfo(
      classname, String(farmProduct), String(marineProduct), String(animalProduct), 
      String(dailyDelivery), String(sweets) ,String(food) ,String(liveCategory),String(processedMeat), 
      String(bread), String(alcohol), String(rice), String(eggAndMilk), String(freezedAndIce), String(deliFoods))
  }

  /**
   * 選定商品一覧小計計算
   * 各項目すべてが空白であれば空白とする。
   * 
   * @param list 
   */
  public calculateSubTotallingSelection(list: SelectionListInfo[]): void {
    // 小計情報
    const subTotals = {
      // 仕入価
      thisTimeCostPrice: { total: 0, hasData: false },
      // 計画数(予測)
      predictPlanNum: { total: 0, hasData: false },
      // 計画数(修正)
      planNum: { total: 0, hasData: false },
      // 計画供給高
      planSupplyBudget: { total: 0, hasData: false }
    };
    // 小計GPR計算用
    let calcGpr_PlanNumCostPrice: number = 0;

    // 小計計算
    // バイヤー承認フラグが、0(未確認) or 1(承認)の商品を対象とする
    list.forEach(item => {
      if (["0", "1"].includes(item.buyerApprovalFlag)) {
        // 仕入価
        if (!PlessViewUtilsSub.isEmpty(item.thisTimeCostPrice)) {
          subTotals.thisTimeCostPrice.total += this.convertStrToNum(item.thisTimeCostPrice);
          subTotals.thisTimeCostPrice.hasData = true;
        }
        // 計画数(予測)
        if (!PlessViewUtilsSub.isEmpty(item.predictPlanNum)) {
          subTotals.predictPlanNum.total += this.convertStrToNum(item.predictPlanNum);
          subTotals.predictPlanNum.hasData = true;
        }
        // 計画数(修正)
        if (!PlessViewUtilsSub.isEmpty(item.planNum)) {
          subTotals.planNum.total += this.convertStrToNum(item.planNum);
          subTotals.planNum.hasData = true;
        } else if (!PlessViewUtilsSub.isEmpty(item.predictPlanNum)) {
          // 計画数(修正)が未入力の場合、計画数(予測)が存在すれば計画数(予測)を使用
          subTotals.planNum.total += this.convertStrToNum(item.predictPlanNum);
          subTotals.planNum.hasData = true;
        }
        // 計画供給高
        if (!PlessViewUtilsSub.isEmpty(item.planSupplyBudget)) {
          subTotals.planSupplyBudget.total += this.convertStrToNum(item.planSupplyBudget);
          subTotals.planSupplyBudget.hasData = true;
        }
        // 各商品の（計画数(修正) * 仕入価）の結果を合算
        calcGpr_PlanNumCostPrice += this.convertStrToNum(item.planNum) * this.convertStrToNum(item.thisTimeCostPrice);
      }
    })

    // GPR計算
    const totalGpr = this.calculateGPR(
      subTotals.planSupplyBudget.hasData ? String(subTotals.planSupplyBudget.total) : null,
      null,
      subTotals.planNum.hasData ? String(subTotals.planNum.total) : null,
      subTotals.thisTimeCostPrice.hasData ? String(subTotals.thisTimeCostPrice.total) : null,
      String(calcGpr_PlanNumCostPrice),
    );

    // 仕入価
    this.kymw7000Model.selectionTotalCostPrice = subTotals.thisTimeCostPrice.hasData ? Number(subTotals.thisTimeCostPrice.total.toFixed(2)) : null;
    // 計画数(予測)
    this.kymw7000Model.selectionTotalPredictPlanNum = subTotals.predictPlanNum.hasData ? subTotals.predictPlanNum.total : null;
    // 計画数(修正)
    this.kymw7000Model.selectionTotalPlanNum = subTotals.planNum.hasData ? subTotals.planNum.total : null;
    // 計画供給高
    this.kymw7000Model.selectionTotalSupplyBudget = subTotals.planSupplyBudget.hasData ? subTotals.planSupplyBudget.total : null;
    // GPR
    this.kymw7000Model.selectionTotalGpr = totalGpr ? Number(totalGpr) : null;
  }

  /**
   * 商品部への選定依頼一覧小計計算
   * 
   * @param list 
   */
  public calculateSubTotallingRequest(list: SelectionRequestInfo[]): void {
    // 小計情報
    const subTotals = {
      // 仕入価
      thisTimeCostPrice: { total: 0, hasData: false },
      // 計画数
      planNum: { total: 0, hasData: false },
      // 計画供給高
      planSupplyBudget: { total: 0, hasData: false }
    };
    // 小計GPR計算用
    let calcGpr_PlanNumCostPrice: number = 0;

    // 0(未依頼)1(未提案)の場合は含む、2(提案済)の場合は含まない
    list.forEach(item => {
      if (["0", "1"].includes(item.requestStatus)) {
        // 仕入価
        if (!PlessViewUtilsSub.isEmpty(item.thisTimeCostPrice)) {
          subTotals.thisTimeCostPrice.total += this.convertStrToNum(item.thisTimeCostPrice);
          subTotals.thisTimeCostPrice.hasData = true;
        }
        // 計画数
        if (!PlessViewUtilsSub.isEmpty(item.planNum)) {
          subTotals.planNum.total += this.convertStrToNum(item.planNum);
          subTotals.planNum.hasData = true;
        }
        // 計画供給高
        if (!PlessViewUtilsSub.isEmpty(item.planSupplyBudget)) {
          subTotals.planSupplyBudget.total += this.convertStrToNum(item.planSupplyBudget);
          subTotals.planSupplyBudget.hasData = true;
        }
        // 各商品の（計画数(修正) * 仕入価）の結果を合算
        calcGpr_PlanNumCostPrice += this.convertStrToNum(item.planNum) * this.convertStrToNum(item.thisTimeCostPrice);
      }
    })

    // GPR計算
    const totalGpr = this.calculateGPR(
      subTotals.planSupplyBudget.hasData ? String(subTotals.planSupplyBudget.total) : null,
      null,
      subTotals.planNum.hasData ? String(subTotals.planNum.total) : null,
      subTotals.thisTimeCostPrice.hasData ? String(subTotals.thisTimeCostPrice.total) : null,
      String(calcGpr_PlanNumCostPrice),
    );

    // 仕入価
    this.kymw7000Model.requestTotalCostPrice = subTotals.thisTimeCostPrice.hasData ? subTotals.thisTimeCostPrice.total : null;
    // 計画数
    this.kymw7000Model.requestTotalPlanNum = subTotals.planNum.hasData ? subTotals.planNum.total : null;
    // 計画供給高
    this.kymw7000Model.requestTotalSupplyBudget = subTotals.planSupplyBudget.hasData ? subTotals.planSupplyBudget.total : null;
    // GPR
    this.kymw7000Model.requestTotalGpr = totalGpr ? Number(totalGpr) : null;
  }

  /**
   * 本年計画計算
   * @param selectionList 
   * @param requestList 
   */
  public calculateThisYearPlan(): void {
    // 計画数
    this.kymw7000Model.requestThisYearPlanNum =
      this.kymw7000Model.selectionTotalPlanNum != null || this.kymw7000Model.requestTotalPlanNum != null
        ? this.kymw7000Model.selectionTotalPlanNum + this.kymw7000Model.requestTotalPlanNum : null;
    // 計画供給高
    this.kymw7000Model.requestThisYearSupplyBudget =
      this.kymw7000Model.selectionTotalSupplyBudget != null || this.kymw7000Model.requestTotalSupplyBudget != null
        ? this.kymw7000Model.selectionTotalSupplyBudget + this.kymw7000Model.requestTotalSupplyBudget : null;
  }

  /**
   * 計画供給高計算
   */
  public calculatePlanSupplyBudget(item: any): void {
    // 計算に必要な入力がない場合は計画供給高を更新しない
    if (!PlessViewUtilsSub.isEmpty(item.thisTimeSupplyPrice)) {
      if (!PlessViewUtilsSub.isEmpty(item.planNum)) {
        item.planSupplyBudget = String(this.convertStrToNum(item.thisTimeSupplyPrice) * this.convertStrToNum(item.planNum));
      } else if (!PlessViewUtilsSub.isEmpty(item.predictPlanNum)) {
        item.planSupplyBudget = String(this.convertStrToNum(item.thisTimeSupplyPrice) * this.convertStrToNum(item.predictPlanNum));
      }
    }
  }

  /**
   * 各種集計（GPR, 小計, 本年計画）
   * 一覧の更新も実施する。
   * 
   * @memberof KYMW7000Component
   * @param selectionListType 選定一覧タイプ
   * @param item 一覧の各商品情報
   */
  private calculateSelectionListSummary(selectionListType: SelectionListType, item: any): void {
    let gpr: string = '';
    // GPR計算
    gpr = this.calculateGPR(item.planSupplyBudget, item.predictPlanNum, item.planNum, item.thisTimeCostPrice);
    if (this.convertStrToNum(gpr) < 0) {
      this.dialogService.openAlertGetMessage('E0622');
      item.planSupplyBudget = '';
      return
    } else {
      item.gpr = gpr;
    }
    
    // 各一覧別処理
    if (selectionListType === SelectionListType.SelectionGoods) {
      // 選定商品一覧
      // 一覧更新
      this.dtg_SelectionGoodsList.refresh();
      // 小計計算
      this.calculateSubTotallingSelection(this.kymw7000Model.SelectionList);
    } else {
      // 選定依頼一覧
      // 一覧更新
      this.dtg_SelectionRequestList.refresh();
      // 小計計算
      this.calculateSubTotallingRequest(this.kymw7000Model.SelectionRequestInfo);
    }

    // 本年計画計算
    this.calculateThisYearPlan();
  }

  /**
   * 集計計算（選定数、依頼数）
   */
  private calculateTotallingInfo(): void {
    const totallingInfo = [];
    // 選定数
    totallingInfo.push(
      this.calculateTotalling(this.kymw7000Model.SelectionList, "選定数")
    );
    // 依頼数
    totallingInfo.push(
      this.calculateTotalling(this.kymw7000Model.SelectionRequestInfo, "依頼数")
    );

    this.kymw7000Model.TotallingInfo = totallingInfo;
  }

  /**
   * 数値でないかどうかを判定する(String版)
   * [戻り値]true：数値ではない／false：数値
   *
     * @param value 判定する文字列
   */
  public isNaNString(value: string): boolean {
    return isNaN(Number(value));
  }

   /**
   * 文字列の桁数チェック
   * @param value : 対象文字列
   * @param value : 最大桁数
   * @return true : 桁数正常
   *         false : 桁数オーバー
   */
  public isMaxLength(value: string, num: number): boolean {
    let result = true;
    if (!PlessViewUtilsSub.isEmpty(value)) {
      if (value.length > num) {
        result = false;
      }
    }
    return result;
  }

  /**
   * 文字列から数値の変換
   * 空白の場合は0を返す
   * 
   * @param value 
   * @returns 
   */
  public convertStrToNum(value: string): number {
    return !PlessViewUtilsSub.isEmpty(value) ? Number(value) : 0;
  }

  private isValidMediumType(): boolean {
    return !PlessViewUtilsSub.isEmpty(this.kymw7000Model.mediumType) && this.kymw7000Model.mediumType !== 'blankVal';
  }

  private isValidFeatureCode(): boolean  {
    return !PlessViewUtilsSub.isEmpty(this.kymw7000Model.featureCode) && this.kymw7000Model.featureCode !== 'blankVal';
  }
}
